import {RemoteGetBeneficiaryAddressV4} from 'data/usecases';
import {GetBeneficiaryAddressV4} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetBeneficiaryAddressV4 = (): GetBeneficiaryAddressV4 =>
	new RemoteGetBeneficiaryAddressV4(
		makeBFFApiUrl(ProfileChangeDataEndpoints.beneficiaryAddressV4),
		makeAuthorizeHttpClientDecorator(),
	);
